/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import styled from '@emotion/styled';

import Cta from './PageBuilder/Cta';
import RichText from './PageBuilder/RichText';
import Text from './PageBuilder/utilities/Text';
import Container from './oc-container';
import { H3, H5 } from './oc-h';
import Theme from '../../themes';
import { connectLocation } from '../location/LocationConnectors';

// Styled Components
const NewsContainer = styled.div`
  display: block;
  padding: 0;
  margin-bottom: 35px;

  @media screen and (min-width: 768px), screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    margin-bottom: 70px;
  }

  .recent-news-heading-grid {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;

    @media screen and (min-width: 1200px) {
      margin-bottom: 32px;
    }

    .more-news-container {
      display: inline-flex;
      flex-grow: 1;
      justify-content: flex-end;
    }

    .more-news {
      color: black;
      font-size: 14px;
      line-height: 14px;
      text-decoration: none;

      @media screen and (min-width: 1200px),
        screen and (-ms-high-contrast: active),
        screen and (-ms-high-contrast: none) {
        font-size: 18px;
        line-height: 18px;
      }

      .react-chevron-right {
        font-size: 15px;
        margin-left: 10px;
        text-decoration: none;
      }

      &:hover {
        color: ${Theme.colors.brand};
        text-decoration: underline;

        &:after {
          text-decoration: none;
        }
      }
    }
  }
`;

const NewsItemsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  position: relative;
  width: 100%;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const NewsHeading = styled(Text)`
  color: #000000;
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;

  @media screen and (min-width: 1200px) {
    font-size: 18px;
    line-height: 18px;
  }
`;

const StyledNewsItem = styled.div`
  color: #000000;
  display: inline-block;
  font-size: 14px;
  position: relative;

  @media (min-width: 768px) {
    max-width: calc((100% - 64px) / 3);
  }

  @media screen and (min-width: 1200px), screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    font-size: 16px;
  }

  .news-item-prehead {
    border-bottom: 1px solid #000000;
    border-top: 2px solid #000000;
    display: inline-block;
    font-size: 18px;
    font-weight: 700;
    line-height: 18px;
    margin-bottom: 16px;
    padding: 15px 0;
    width: 100%;

    @media screen and (min-width: 1200px),
      screen and (-ms-high-contrast: active),
      screen and (-ms-high-contrast: none) {
      font-size: 21px;
      line-height: 21px;
      padding: 20px 0;
    }
  }

  a {
    justify-self: start;
  }

  p {
    margin: 0;
  }
`;

const NewsItem = ({ prehead, heading, text, cta }) => (
  <StyledNewsItem>
    <Text className="news-item-prehead" content={prehead} />
    <H3><Text content={heading} /></H3>
    <RichText content={text} />
    <Cta {...cta} />
  </StyledNewsItem>
);

const News = ({ cta, ctaText, ctaUrl, news, newsHeading }) => (
  <Container>
    <NewsContainer>
      <div className="recent-news-heading-grid">
        {newsHeading?.display && (
          <NewsHeading content={newsHeading?.text} />
        )}

        {cta && (
          <div className="more-news-container">
            <a href={ctaUrl} className="more-news" data-track="view-more" data-track-content="More News">
              <Text content={ctaText} />
              <span className="react-chevron-right" />
            </a>
          </div>
        )}
      </div>

      <NewsItemsGrid>
        {news ? (
          news.map(item => (
            <NewsItem
              key={`news-item-${item.heading}`}
              prehead={item.prehead}
              heading={item.heading}
              text={item.text}
              cta={item.cta}
            />
          ))
        ) : (
          <p>There are no news items yet.</p>
        )}
      </NewsItemsGrid>
    </NewsContainer>
  </Container>
);

export default News;
